import { store } from './store.js';
import dashboardHTML from '../html/parentsDashboard.html?raw';

if (typeof document !== 'undefined' && !document.getElementById('parentsDashboardScreen')) {
    document.body.insertAdjacentHTML('beforeend', dashboardHTML);
}

const ParentsDashboard = {
    config: {
        accessCode: null,
        charts: {},
        currentMode: 'parent',
        currentTab: 'resumen'
    },

    authState: {
        mode: 'parent',
        selectedUserId: null,
        selectedGroup: '1A'
    },

    show(mode = 'parent') {
        if (window.stopAudio) window.stopAudio();
        this.authState.mode = mode;
        this.authState.selectedUserId = null;

        const modal = document.getElementById('authModal');
        const title = document.getElementById('authTitle');

        if (title) {
            title.textContent = mode === 'teacher' ? '🍎 Acceso Profesores' : '👨‍👩‍👧‍👦 Acceso Padres';
        }

        this.renderAuthContent();
        if (modal) modal.classList.remove('hidden');
    },

    closeAuth() {
        document.getElementById('authModal')?.classList.add('hidden');
        document.getElementById('authError')?.classList.add('hidden');
    },

    renderAuthContent() {
        const container = document.getElementById('authContent');
        if (!container) return;

        container.innerHTML = '';

        if (this.authState.mode === 'teacher') {
            container.innerHTML = `
                <p style="margin-bottom: 1rem;">Introduce tu PIN de Profesor:</p>
                <input type="password" id="authPinInput" maxlength="4" class="pin-input" placeholder="****" 
                    onkeyup="if(event.key === 'Enter') window.ParentsDashboard.checkAuth()"
                    style="font-size: 2rem; width: 150px; text-align: center; border: 2px solid #ddd; border-radius: 10px; padding: 0.5rem;">
                <button class="btn btn-primary" style="display: block; width: 100%; margin-top: 1rem;" onclick="window.ParentsDashboard.checkAuth()">Entrar</button>
            `;
            setTimeout(() => document.getElementById('authPinInput')?.focus(), 100);

        } else {
            if (this.authState.selectedUserId) {
                const users = window.UserManager?.users || [];
                const user = users.find(u => u.id === this.authState.selectedUserId);
                if (!user) {
                    this.authState.selectedUserId = null;
                    this.renderAuthContent();
                    return;
                }
                container.innerHTML = `
                    <div style="margin-bottom: 1rem;">
                        <span style="font-size: 2rem;">${window.LoginScreen?.getAvatarURL(user.avatar) || '👤'}</span>
                        <p><strong>${window.sanitizeString ? window.sanitizeString(user.name) : user.name}</strong></p>
                    </div>
                    <p style="margin-bottom: 0.5rem;">Introduce el PIN de este alumno:</p>
                    <input type="password" id="authPinInput" maxlength="4" class="pin-input" placeholder="****" 
                        onkeyup="if(event.key === 'Enter') window.ParentsDashboard.checkAuth()"
                        style="font-size: 2rem; width: 150px; text-align: center; border: 2px solid #ddd; border-radius: 10px; padding: 0.5rem;">
                     
                    <div style="display: flex; gap: 0.5rem; margin-top: 1rem;">
                        <button class="btn btn-secondary" onclick="window.ParentsDashboard.show('parent')">Atrás</button>
                        <button class="btn btn-primary" onclick="window.ParentsDashboard.checkAuth()" style="flex-grow: 1;">Entrar</button>
                    </div>
                `;
                setTimeout(() => document.getElementById('authPinInput')?.focus(), 100);

            } else {
                const users = window.UserManager?.users || [];
                if (users.length === 0) {
                    container.innerHTML = '<p>No hay alumnos registrados.</p>';
                } else {
                    const list = users.map(u => `
                        <div class="auth-user-card" onclick="window.ParentsDashboard.selectUserForAuth('${u.id}')" 
                             style="display: flex; align-items: center; padding: 0.5rem; border: 1px solid #eee; border-radius: 8px; margin-bottom: 0.5rem; cursor: pointer; transition: background 0.2s;">
                            <span style="font-size: 1.5rem; margin-right: 1rem;">${window.LoginScreen?.getAvatarURL(u.avatar) || '👤'}</span>
                            <span style="font-weight: 600;">${window.sanitizeString ? window.sanitizeString(u.name) : u.name}</span>
                        </div>
                    `).join('');
                    container.innerHTML = `<p style="margin-bottom: 1rem;">Selecciona a tu hijo/a:</p><div style="max-height: 300px; overflow-y: auto;">${list}</div>`;
                }
            }
        }
    },

    selectUserForAuth(userId) {
        this.authState.selectedUserId = userId;
        this.renderAuthContent();
    },

    checkAuth() {
        const inputEl = document.getElementById('authPinInput');
        const input = inputEl ? inputEl.value : '';
        const errorMsg = document.getElementById('authError');

        let isValid = false;

        if (this.authState.mode === 'teacher') {
            isValid = input === (window.UserManager?.getTeacherPin?.() || '1234');
        } else {
            const user = (window.UserManager?.users || []).find(u => u.id === this.authState.selectedUserId);
            isValid = user && user.pin === input;
        }

        if (isValid) {
            this.closeAuth();
            this.openDashboard(this.authState.mode);
        } else if (errorMsg) {
            errorMsg.classList.remove('hidden');
            setTimeout(() => errorMsg.classList.add('hidden'), 2000);
        }
    },



    switchTab(tabName) {
        this.config.currentTab = tabName;

        document.querySelectorAll('.tab-btn').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.tab === tabName);
        });

        const resEl = document.getElementById('tabResumen');
        if (resEl) resEl.style.display = tabName === 'resumen' ? 'block' : 'none';
        const alumEl = document.getElementById('tabAlumnos');
        if (alumEl) alumEl.style.display = tabName === 'alumnos' ? 'block' : 'none';
        const notEl = document.getElementById('tabNotas');
        if (notEl) notEl.style.display = tabName === 'notas' ? 'block' : 'none';

        const tabProblemas = document.getElementById('tabProblemas');
        if (tabProblemas) {
            tabProblemas.style.display = tabName === 'problemas' ? 'block' : 'none';
            if (tabName === 'problemas') {
                this.renderCustomProblemsList();
            }
        }
    },

    renderCustomProblemsList() {
        const listContainer = document.getElementById('customProblemsList');
        if (!listContainer || !window.CustomProblemManager) return;

        const problems = CustomProblemManager.getAll().reverse(); // Show newest first

        if (problems.length === 0) {
            listContainer.innerHTML = '<p style="text-align: center; color: #94a3b8; padding: 2rem;">No hay problemas personalizados creados.</p>';
            return;
        }

        listContainer.innerHTML = problems.map(p => `
            <div class="custom-problem-card" style="background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 8px; padding: 1rem; margin-bottom: 0.8rem;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem;">
                    <div style="flex-grow: 1;">
                        <div style="font-size: 0.8rem; color: #64748b; margin-bottom: 0.3rem; display: flex; gap: 10px;">
                            <span style="font-weight: 600; color: #475569;">${new Date(p.created).toLocaleDateString()}</span>
                            <span>• Nivel: ${p.level}</span>
                            <span>• ${p.type === 'sum' ? 'Suma' : 'Resta'}</span>
                        </div>
                        <p style="margin: 0; color: #1e293b; font-weight: 500;">${p.statement}</p>
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 0.5rem; min-width: 120px;">
                        <button onclick="window.ParentsDashboard.launchCustomProblem('${p.id}')" 
                                class="btn-primary" 
                                style="font-size: 0.8rem; padding: 0.5rem; width: 100%; border-radius: 6px;">
                            🚀 LANZAR
                        </button>
                        <button onclick="window.ParentsDashboard.deleteCustomProblem('${p.id}')" 
                                class="btn-text-only" 
                                style="font-size: 0.8rem; color: #ef4444; width: 100%; text-align: center;">
                            🗑️ Eliminar
                        </button>
                    </div>
                </div>
            </div>
        `).join('');
    },

    /**
     * Lanza un problema personalizado específico
     */
    launchCustomProblem(id) {
        if (!window.CustomProblemManager || !window.SessionManager) return;

        const problems = CustomProblemManager.getAll();
        const problem = problems.find(p => p.id === id);

        if (!problem) {
            alert('Error: Problema no encontrado.');
            return;
        }

        if (confirm('¿Quieres lanzar este problema ahora para que los alumnos lo resuelvan?')) {
            // Convertir a formato interno
            const internalProblem = CustomProblemManager.convertToInternalFormat(problem);

            // Preparar la sesión solo con este problema
            if (store.config) {
                store.config.problemType = internalProblem.type;
                store.config.level = internalProblem.level;
                store.config.context = internalProblem.contextId;
            }

            // Inyectar en SessionManager
            window.SessionManager.state.problems = [internalProblem];
            window.SessionManager.state.currentProblem = 0;
            window.SessionManager.state.answers = {};
            window.SessionManager.state.score = 0;

            // Cerrar dashboard y empezar
            this.close();
            window.SessionManager.showNarrativeIntro();
        }
    },

    /**
     * Elimina un problema personalizado
     */
    deleteCustomProblem(id) {
        if (!window.CustomProblemManager) return;

        if (confirm('¿Estás seguro de que quieres eliminar este problema permanentemente?')) {
            CustomProblemManager.deleteProblem(id);
            this.renderCustomProblemsList(); // Refrescar lista
        }
    },

    /**
     * Elimina TODOS los problemas personalizados
     */
    deleteAllCustomProblems() {
        if (!window.CustomProblemManager) return;
        const problems = CustomProblemManager.getAll();

        if (problems.length === 0) {
            alert('No hay problemas para borrar.');
            return;
        }

        if (confirm(`¿Estás seguro de que quieres ELIMINAR TODOS (${problems.length}) los problemas generados? Esta acción no se puede deshacer.`)) {
            CustomProblemManager.deleteAll();
            this.renderCustomProblemsList();
        }
    },

    /**
     * Render clickable student cards in the Alumnos tab
     */
    /**
     * Render clickable student cards in the Alumnos tab
     */
    renderStudentCards() {
        const container = document.getElementById('studentCardsGrid');
        if (!container || !window.UserManager) return;

        // 1. Render Class Selector (Teacher Only)
        let selectorHTML = '';
        if (this.authState.mode === 'teacher') {
            const groups = ['1A', '1B', '1C', 'Todas'];
            const buttons = groups.map(g =>
                `<button class="group-filter-btn ${this.authState.selectedGroup === g ? 'active' : ''}" 
                        onclick="window.ParentsDashboard.setGroup('${g}')">${g}</button>`
            ).join('');

            selectorHTML = `
                <div class="class-selector" style="margin-bottom: 0.5rem; display: flex; gap: 0.5rem; align-items: center;">
                    <span style="font-weight: 600; color: #475569;">Filtrar por Clase:</span>
                    ${buttons}
                </div>
            `;
        }

        // Render Selector in its own container
        const selectorContainer = document.getElementById('classSelectorContainer');
        if (selectorContainer) {
            selectorContainer.innerHTML = selectorHTML;
        }

        const users = window.UserManager.users;
        const currentGroup = this.authState.selectedGroup;

        // 2. Filter Users
        const filteredUsers = users.filter(u =>
            this.authState.mode === 'parent' || // Parents see all (or filtered by auth later) - actually parents don't see this tab usually
            currentGroup === 'Todas' ||
            (u.group || '1A') === currentGroup
        );

        if (filteredUsers.length === 0) {
            container.innerHTML = selectorHTML + '<p class="no-students-message">No hay alumnos en esta clase.</p>';
            return;
        }

        // 3. Render Cards
        const cardsHTML = filteredUsers.map(user => {
            // Get avatar emoji
            const avatarEmoji = (window.LoginScreen && user.avatar)
                ? window.LoginScreen.getAvatarURL(user.avatar)
                : '👤';

            // Get quick progress summary
            const userProgress = this.getUserProgress(user.id);
            const problemsText = userProgress ? `${userProgress.problemsCompleted} prob.` : 'Sin datos';

            // Show PIN if Teacher
            const pinBadge = this.authState.mode === 'teacher'
                ? `<div style="font-size: 0.8rem; background: #e2e8f0; padding: 2px 6px; border-radius: 4px; margin-top: 4px;">PIN: ${user.pin || '1234'}</div>`
                : '';

            return `
                <div class="student-card" onclick="window.ParentsDashboard.showStudentReport('${user.id}', '${this.authState.mode}')">
                    <div class="student-avatar">${avatarEmoji}</div>
                    <div class="student-name">${window.sanitizeString ? window.sanitizeString(user.name) : user.name}</div>
                    <div class="student-group" style="font-size: 0.8rem; color: #64748b;">${user.group || '1A'}</div>
                    <div class="student-progress">${problemsText}</div>
                    ${pinBadge}
                </div>
    `;
        }).join('');

        container.innerHTML = cardsHTML;
    },

    setGroup(group) {
        this.authState.selectedGroup = group;
        this.renderStudentCards();
    },

    /**
     * Get progress for a specific user
     */
    getUserProgress(userId) {
        if (!window.GamificationService) return null;
        return window.GamificationService.getUserProgress(userId);
    },

    /**
     * Render Standards Table (Teacher only)
     */
    renderStandards(stats, progress) {
        const table = document.getElementById('reportStandardsTable');
        if (!table) return;

        // Helper to get status icon
        const getStatus = (condition) => condition ? '✅' : '⏳';

        // MAT.1.1.1 & 1.1.2: Based on reading/identifying (mocked by problem completion)
        const hasCompletedProblems = progress.problemsCompleted > 0;
        document.getElementById('std111').textContent = getStatus(hasCompletedProblems);
        document.getElementById('std112').textContent = getStatus(hasCompletedProblems);

        // MAT.1.2.1: Based on calc success rate (>50%)
        const calcSuccess = (stats.suma.correct + stats.resta.correct) > 5;
        document.getElementById('std121').textContent = getStatus(calcSuccess);

        // MAT.1.2.2: Mental calculation (mocked: check if played)
        document.getElementById('std122').textContent = getStatus(hasCompletedProblems);

        // MAT.1.3.1: Solve problems (completed > 3)
        document.getElementById('std131').textContent = getStatus(progress.problemsCompleted > 3);

        // MAT.1.4.1: Communicate result (completed > 0)
        document.getElementById('std141').textContent = getStatus(hasCompletedProblems);
    },

    /**
     * Open the actual dashboard screen
     * @param {string} mode - 'teacher' or 'parent'
     */
    openDashboard(mode = 'parent') {
        if (window.stopAudio) window.stopAudio();
        // Hide other screens
        document.querySelectorAll('.screen').forEach(s => {
            if (!s.classList.contains('hidden')) s.classList.add('hidden');
        });

        const dashboard = document.getElementById('parentsDashboardScreen');
        dashboard.classList.remove('hidden');
        dashboard.classList.add('active');

        this.renderDashboard(mode);
    },

    /**
     * Render dashboard content
     * @param {string} mode - 'teacher' | 'parent'
     */
    renderDashboard(mode) {
        if (!window.GamificationService) return;

        const teacherTabs = document.getElementById('teacherTabs');
        const parentRecommendation = document.getElementById('parentRecommendationSection');
        const titleEl = document.querySelector('#parentsDashboardScreen .main-title');
        const roleLabel = document.getElementById('dashboardRoleLabel');
        const btnAula = document.getElementById('btnModoAulaMock');

        if (mode === 'parent') {
            // PARENT MODE
            if (teacherTabs) teacherTabs.style.display = 'none';
            if (btnAula) btnAula.style.display = 'none';
            if (parentRecommendation) parentRecommendation.style.display = 'block';
            if (titleEl) titleEl.textContent = "Panel de Progreso 📊";
            if (roleLabel) {
                roleLabel.innerHTML = `
                    ZONA DE PADRES 👨‍👩‍👧‍👦
                    <button onclick="if(confirm('¿Desbloquear todos los mini-juegos?')) CurricularGamification.debugUnlockAll()" 
                            style="font-size: 0.7rem; background: #ef4444; color: white; border: none; border-radius: 4px; padding: 4px 8px; margin-left: 15px; cursor: pointer; font-weight: bold; vertical-align: middle;">
                        🔓 DESBLOQUEAR JUEGOS
                    </button>
                `;
            }

            // Show only resumen tab
            this.switchTab('resumen');
        } else {
            // TEACHER MODE
            if (teacherTabs) teacherTabs.style.display = 'flex';
            if (btnAula) {
                btnAula.style.display = 'block';
                btnAula.onclick = () => {
                    alert('🎓 MODO AULA SINCORNIZADO (DEMO EDITORIAL)\\n\\nEn la versión con backend, los alumnos escanearán el QR "AULA-4B" y el profesor verá en tiempo real por qué paso va cada alumno.\\n\\n[Función Premium]');
                };
            }
            if (parentRecommendation) parentRecommendation.style.display = 'none';
            if (titleEl) titleEl.textContent = "Panel de Control 📊";
            if (roleLabel) {
                roleLabel.innerHTML = `
                    ZONA DE PROFESORES 🍎 
                    <button onclick="window.ParentsDashboard.changeTeacherPin()" 
                            style="font-size: 0.7rem; background: none; border: 1px solid #334155; border-radius: 4px; padding: 2px 6px; margin-left: 10px; cursor: pointer;">
                        Cambiar PIN
                    </button>
                    <button onclick="if(confirm('¿Desbloquear todos los mini-juegos?')) CurricularGamification.debugUnlockAll()" 
                            style="font-size: 0.7rem; background: #ef4444; color: white; border: none; border-radius: 4px; padding: 4px 8px; margin-left: 15px; cursor: pointer; font-weight: bold; vertical-align: middle;">
                        🔓 DESBLOQUEAR JUEGOS
                    </button>
                    <button onclick="if(window.activateCommercialDemo) window.activateCommercialDemo()" 
                            style="font-size: 0.7rem; background: #8b5cf6; color: white; border: none; border-radius: 4px; padding: 4px 8px; margin-left: 10px; cursor: pointer; font-weight: bold; vertical-align: middle; box-shadow: 0 2px 4px rgba(139,92,246,0.3);">
                        ✨ MODO DEMO
                    </button>
                `;
            }

            // Render student cards
            this.renderStudentCards();
            this.loadNotes();
        }

        const progress = window.GamificationService.getProgress();

        // [NEW] Calculate Class Average for Teacher Mode
        let classAvgTime = 0;
        if (mode === 'teacher' && window.UserManager && window.UserManager.users.length > 0) {
            let totalTimes = [];
            window.UserManager.users.forEach(u => {
                const p = this.getUserProgress(u.id);
                if (p && p.sessionHistory && p.sessionHistory.length > 0) {
                     // ... logic
                }
            });
        }
    },

    /**
     * Resumen de analítica de errores categorizados por fase pedagógica (Analítica Docente Avanzada)
     */
    getErrorAnalyticsSummary() {
        try {
            const records = JSON.parse(localStorage.getItem('detectimaticas_error_analytics') || '[]');
            const counts = {
                COMPREHENSION_ERROR: 0,
                REPRESENTATION_ERROR: 0,
                OPERATION_SELECTION_ERROR: 0,
                CALCULATION_ERROR: 0
            };
            records.forEach(r => {
                if (counts[r.errorType] !== undefined) {
                    counts[r.errorType]++;
                }
            });
            return counts;
        } catch (_e) {
            return { COMPREHENSION_ERROR: 0, REPRESENTATION_ERROR: 0, OPERATION_SELECTION_ERROR: 0, CALCULATION_ERROR: 0 };
        }
    },

    /**
     * Show detailed student report modal
     * @param {string} userId
     * @param {string} mode - 'teacher' | 'parent'
     */
    showStudentReport(userId, mode = 'teacher') {
        const modal = document.getElementById('studentReportModal');
        if (!modal || !window.UserManager) return;

        const user = window.UserManager.users.find(u => u.id === userId);
        // Fallback for parent mode if userId is null -> get current user
        const targetUser = user || (mode === 'parent' ? window.UserManager.currentUser : null);

        if (!targetUser) {
            console.error("No target user found for report");
            return;
        }

        // Get avatar
        const avatarEmoji = (window.LoginScreen && targetUser.avatar)
            ? window.LoginScreen.getAvatarURL(targetUser.avatar)
            : '👤';

        // Get progress data
        const progress = this.getUserProgress(targetUser.id);
        const stats = progress ? progress.stats : { suma: { correct: 0, attempted: 0 }, resta: { correct: 0, attempted: 0 } };

        // Calculate percentages
        const sumaPercent = stats.suma.attempted > 0
            ? Math.round((stats.suma.correct / stats.suma.attempted) * 100)
            : 0;
        const restaPercent = stats.resta.attempted > 0
            ? Math.round((stats.resta.correct / stats.resta.attempted) * 100)
            : 0;
        const totalPercent = (sumaPercent + restaPercent) / 2;

        // Populate modal Basic Info
        document.getElementById('reportStudentAvatar').textContent = avatarEmoji;

        // Add Change PIN button next to name
        const nameContainer = document.getElementById('reportStudentName');
        nameContainer.innerHTML = `
            ${window.sanitizeString ? window.sanitizeString(targetUser.name) : targetUser.name}
<button onclick="window.ParentsDashboard.changeUserPin('${targetUser.id}')"
    class="btn-text-only"
    style="font-size: 0.8rem; margin-left: 10px; color: #6366F1; text-decoration: underline;">
    Cambiar PIN
</button>
`;

        document.getElementById('reportProblems').textContent = progress ? progress.problemsCompleted : 0;
        document.getElementById('reportSumas').textContent = `${sumaPercent}% `;
        document.getElementById('reportRestas').textContent = `${restaPercent}% `;
        document.getElementById('reportLevel').textContent = progress ? progress.level : 1;

        // Map competencies/skills
        this.renderCompetencies(sumaPercent, restaPercent, totalPercent);

        // Generate difficulties and proposals
        this.generateDifficultiesAndProposals(sumaPercent, restaPercent, stats);

        // Render Standards (populate table)
        this.renderStandards(stats, progress || { problemsCompleted: 0 });

        // [NEW] Populate Analytics Fields
        this.renderPedagogicalAnalytics(progress);

        // ADJUST VISIBILITY BASED ON MODE
        const legalSection = document.querySelector('.report-legal');
        const standardsSection = document.getElementById('reportStandardsTable')?.closest('.report-section');
        const competenciesTitle = document.querySelector('.report-section h4'); // The first h4 is competencies

        if (mode === 'parent') {
            // Hide Teacher/Legal specifics
            if (legalSection) legalSection.style.display = 'none';
            if (standardsSection) standardsSection.style.display = 'none';

            // Rename Competencies for Parents
            if (competenciesTitle) competenciesTitle.textContent = "🧠 Habilidades Desarrolladas";

            // Rename Competency Labels for Parents
            const labels = {
                'CMCT (Matemática)': 'Razonamiento Matemático',
                'CCL (Lingüística)': 'Comprensión Lectora',
                'CPAA (Aprender)': 'Constancia',
                'SIE (Iniciativa)': 'Resolución de Problemas'
            };

            document.querySelectorAll('.competency-label').forEach(el => {
                const originalText = el.textContent;
                Object.keys(labels).forEach(key => {
                    if (originalText.includes(key.split(' ')[0])) {
                        el.textContent = labels[key];
                    }
                });
            });

        } else {
            // Teacher Mode: Show everything
            if (legalSection) legalSection.style.display = 'flex';
            if (standardsSection) standardsSection.style.display = 'block';
            if (competenciesTitle) competenciesTitle.textContent = "🎯 Competencias (LOMLOE)";

            // Restore Competency Labels
            const labels = {
                'Razonamiento Matemático': 'CMCT (Matemática)',
                'Comprensión Lectora': 'CCL (Lingüística)',
                'Constancia': 'CPAA (Aprender a Aprender)',
                'Resolución de Problemas': 'SIE (Iniciativa)'
            };
            document.querySelectorAll('.competency-label').forEach(el => {
                const text = el.textContent;
                if (labels[text]) el.textContent = labels[text];
            });
        }

        // Configure Download Button
        const downloadBtn = document.getElementById('btnDownloadIndividualReport');
        if (downloadBtn) {
            downloadBtn.onclick = () => {
                if (window.ReportGenerator) {
                    ReportGenerator.generateSessionReport(progress);
                } else {
                    window.print(); // Fallback for DEMO
                }
            };
        }

        // ED-02: CSV Export for Editorial Demo
        const csvBtn = document.getElementById('btnDownloadIndividualReportCSV');
        if (csvBtn) {
            csvBtn.onclick = () => {
                const user = window.UserManager.users.find(u => u.id === progress.userId);
                const name = user ? user.name : 'Alumno';
                
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += "Parametro,Valor\n";
                csvContent += `Nombre,${name}\n`;
                csvContent += `Nivel,${progress.level}\n`;
                csvContent += `Problemas Resueltos,${progress.totalProblems}\n`;
                
                const stats = progress.operationStats || {};
                csvContent += `Eficacia Sumas,${Math.round((stats.suma?.correct / Math.max(1, stats.suma?.total)) * 100 || 0)}%\n`;
                csvContent += `Eficacia Restas,${Math.round((stats.resta?.correct / Math.max(1, stats.resta?.total)) * 100 || 0)}%\n`;

                const encodedUri = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", `informe_${name.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
        }

        // Show modal
        modal.classList.remove('hidden');
    },

    /**
     * Render pedagogical analytics (time and evolution)
     */
    renderPedagogicalAnalytics(progress) {
        const timeDisplay = document.getElementById('avgTimePerProblem');
        const efficiencyDisplay = document.getElementById('efficiencyLevel');
        const chartContainer = document.getElementById('temporalEvolutionChart');

        if (!timeDisplay || !efficiencyDisplay || !chartContainer) return;

        const history = progress && progress.sessionHistory ? progress.sessionHistory : [];

        if (history.length === 0) {
            timeDisplay.textContent = '-- s';
            efficiencyDisplay.textContent = '--';
            chartContainer.innerHTML = '<div style="flex:1; text-align:center; color:#94a3b8; font-size:0.7rem;">Sin datos suficientes</div>';
            return;
        }

        // 1. Calculate Average Time
        const totalDuration = history.reduce((acc, curr) => acc + curr.duration, 0);
        const avgTime = Math.round(totalDuration / history.length);
        timeDisplay.textContent = `${avgTime}s`;

        // 2. Efficiency Level
        let efficiency = 'Detective Junior';
        let alertText = "";
        let alertColor = "#64748b";

        if (avgTime < 25) {
            efficiency = 'Maestro Detective';
            alertText = "✅ ¡Excelente fluidez! Este alumno domina las estrategias de cálculo.";
            alertColor = "#10b981";
        } else if (avgTime < 50) {
            efficiency = 'Detective Senior';
            alertText = "👍 Progreso adecuado. Sigue consolidando la velocidad.";
            alertColor = "#3b82f6";
        } else {
            efficiency = 'Detective Junior';
            alertText = "⚠️ Atención: Tiempo elevado. Podría necesitar apoyo en sus estrategias de conteo.";
            alertColor = "#f59e0b";
        }

        efficiencyDisplay.textContent = efficiency;
        efficiencyDisplay.style.color = alertColor;

        // Inyectar alerta si estamos en modo profesor
        const analyticsContainer = document.querySelector('.report-analytics');
        let alertEl = document.getElementById('pedagogicalAlert');
        if (!alertEl) {
            alertEl = document.createElement('div');
            alertEl.id = 'pedagogicalAlert';
            alertEl.style.cssText = 'margin-top: 15px; padding: 10px; border-radius: 8px; font-size: 0.8rem; font-weight: 600;';
            analyticsContainer.appendChild(alertEl);
        }
        alertEl.textContent = alertText;
        alertEl.style.background = alertColor + '20'; // 20% opacity
        alertEl.style.color = alertColor;
        alertEl.style.border = `1px solid ${alertColor}`;

        // 3. Temporal Evolution Chart (Last 10 problems)
        const lastEntries = history.slice(-10);
        const maxDuration = Math.max(...lastEntries.map(e => e.duration), 60);

        chartContainer.innerHTML = '';
        lastEntries.forEach((entry, idx) => {
            const height = Math.min(100, (entry.duration / maxDuration) * 100);
            const bar = document.createElement('div');
            // Redder if slower, bluer if faster
            const hue = Math.max(0, 220 - (height * 2)); // 220 (blue) to 20 (red)

            bar.style.cssText = `
                flex: 1; 
                height: ${height}%; 
                background: hsl(${hue}, 70%, 60%); 
                border-radius: 4px 4px 0 0;
                transition: height 0.5s ease-out;
                position: relative;
                min-width: 15px;
            `;

            bar.title = `T: ${entry.duration}s (${entry.type})`;

            // Add label for last one
            if (idx === lastEntries.length - 1) {
                const label = document.createElement('span');
                label.style.cssText = 'position:absolute; bottom:-18px; left:50%; transform:translateX(-50%); font-size:0.6rem; font-weight:bold; color:#64748b;';
                label.textContent = 'Hoy';
                bar.appendChild(label);
            }

            chartContainer.appendChild(bar);
        });
    },

    /**
     * Render LOMLOE competency bars
     */
    renderCompetencies(sumaPercent, restaPercent, totalPercent) {
        // CMCT (Matemática): Based on overall calculation accuracy
        const cmct = Math.round(totalPercent);
        document.getElementById('barCMCT').style.width = `${cmct}% `;
        document.getElementById('textCMCT').textContent = `${cmct}% `;

        // CCL (Lingüística): Assumed based on problem completion (understanding statements)
        // 80% weight from total, 20% bonus for completion
        const ccl = Math.min(100, Math.round(totalPercent * 0.8 + 20));
        document.getElementById('barCCL').style.width = `${ccl}% `;
        document.getElementById('textCCL').textContent = `${ccl}% `;

        // CPAA (Aprender a Aprender): Based on consistency and improvement
        // For now, 90% if doing well, else proportional
        const cpaa = totalPercent > 60 ? 90 : Math.round(totalPercent * 1.2);
        document.getElementById('barCPAA').style.width = `${Math.min(100, cpaa)}% `;
        document.getElementById('textCPAA').textContent = `${Math.min(100, cpaa)}% `;

        // SIE (Iniciativa): Based on trying both operations
        const triedBoth = sumaPercent > 0 && restaPercent > 0;
        const sie = triedBoth ? Math.min(100, Math.round(totalPercent + 15)) : Math.round(totalPercent * 0.7);
        document.getElementById('barSIE').style.width = `${sie}% `;
        document.getElementById('textSIE').textContent = `${sie}% `;
    },

    /**
     * Generate difficulties and improvement proposals
     * Based on Plan Lógico Matemático and Decreto 209/2022
     */
    generateDifficultiesAndProposals(sumaPercent, restaPercent, stats) {
        const difficulties = [];
        const proposals = [];

        // Analyze difficulties
        if (stats.suma.attempted === 0 && stats.resta.attempted === 0) {
            difficulties.push('Sin datos suficientes para analizar');
            proposals.push('Animar al alumno a practicar más problemas');
        } else {
            // Check suma performance
            if (sumaPercent < 50) {
                difficulties.push('Dificultad con operaciones de SUMA / juntar cantidades');
                proposals.push('Usar representación visual (barras) antes del cálculo numérico');
                proposals.push('Practicar con el método vertical con cuadrícula coloreada');
            } else if (sumaPercent < 70) {
                difficulties.push('Rendimiento moderado en SUMA - reforzar llevadas');
                proposals.push('Enfocarse en sumas con llevadas usando manipulativos');
            }

            // Check resta performance
            if (restaPercent < 50) {
                difficulties.push('Dificultad con operaciones de RESTA / quitar cantidades');
                proposals.push('Trabajar la comprensión de "quitar" con contextos familiares');
                proposals.push('Usar la representación visual para "tachar" elementos');
            } else if (restaPercent < 70) {
                difficulties.push('Rendimiento moderado en RESTA - consolidar concepto');
                proposals.push('Practicar conteo regresivo con juegos');
            }

            // Check disparity between operations
            if (Math.abs(sumaPercent - restaPercent) > 30) {
                if (sumaPercent > restaPercent) {
                    difficulties.push('Gran diferencia: domina suma pero no resta');
                    proposals.push('Sesiones específicas de resta en nivel Aprendiz');
                } else {
                    difficulties.push('Gran diferencia: mejor en resta que en suma');
                    proposals.push('Repasar suma básica con contextos motivadores');
                }
            }

            // If doing well
            if (sumaPercent >= 80 && restaPercent >= 80) {
                difficulties.length = 0;
                difficulties.push('Sin dificultades significativas detectadas');
                proposals.push('Avanzar a problemas de nivel Genio');
                proposals.push('Introducir problemas con datos distractores');
            }
        }

        // Render difficulties
        const diffList = document.getElementById('reportDifficulties');
        diffList.innerHTML = difficulties.map(d => `< li > ${d}</li > `).join('');

        // Render proposals
        const propList = document.getElementById('reportProposals');
        propList.innerHTML = proposals.map(p => `< li > ${p}</li > `).join('');
    },

    /**
     * Close student report modal
     */
    closeStudentReport() {
        document.getElementById('studentReportModal').classList.add('hidden');
    },

    /**
     * Show criteria documentation modal
     */
    showCriteriaModal() {
        document.getElementById('criteriaModal').classList.remove('hidden');
    },

    /**
     * Close criteria documentation modal
     */
    closeCriteriaModal() {
        document.getElementById('criteriaModal').classList.add('hidden');
    },

    /**
     * Load teacher notes from storage
     */
    loadNotes() {
        if (!window.UserManager) return;
        const notes = window.UserManager.loadData('teacher_notes') || '';
        const textarea = document.getElementById('teacherNotes');
        if (textarea) textarea.value = notes;
    },

    /**
     * Save teacher notes
     */
    saveNotes() {
        if (!window.UserManager) return;
        const textarea = document.getElementById('teacherNotes');
        if (textarea) {
            window.UserManager.saveData('teacher_notes', textarea.value);
            alert('Notas guardadas correctamente');
        }
    },

    /**
     * Lista todos los alumnos para que el profesor conozca sus "contraseñas visuales"
     */
    renderClassManagement() {
        const container = document.getElementById('classUsersTable');
        if (!container || !window.UserManager) return;

        const users = window.UserManager.users;

        if (users.length === 0) {
            container.innerHTML = '<p class="no-students-message">No hay alumnos registrados.</p>';
            return;
        }

        container.innerHTML = users.map(user => {
            // Obtener el emoji del avatar
            const avatarEmoji = (window.LoginScreen && user.avatar) ? window.LoginScreen.getAvatarURL(user.avatar) : '👤';

            return `
    < div class="class-user-row" >
                    <div class="class-user-info">
                        <div class="class-user-avatar" style="font-size: 2rem; display: flex; align-items: center; justify-content: center;">
                            ${avatarEmoji}
                        </div>
                        <div class="class-user-details">
                            <h4>${user.name}</h4>
                            <p>Dibujo Secreto: <strong>${user.avatar}</strong></p>
                        </div>
                    </div>
                    <div class="class-user-stats" style="font-size: 0.85rem; color: #64748b; text-align: right;">
                        <div>Último acceso: ${user.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : 'Nunca'}</div>
                    </div>
                </div >
    `;
        }).join('');
    },

    /**
     * Render a performance bar for a specific operation
     */
    renderStatsBar(type, stats) {
        if (!stats || stats.attempted === 0) {
            const barEl = document.getElementById(`bar-${type}`);
            const textEl = document.getElementById(`text-${type}`);
            if (barEl) barEl.style.width = '0%';
            if (textEl) textEl.textContent = 'Sin datos';
            return;
        }

        const percentage = Math.round((stats.correct / stats.attempted) * 100);
        const bar = document.getElementById(`bar-${type}`);
        const text = document.getElementById(`text-${type}`);

        // Animate width
        if (bar) {
            setTimeout(() => {
                bar.style.width = `${percentage}%`;
            }, 100);

            // Color coding
            if (percentage >= 80) bar.style.backgroundColor = '#10B981'; // Green
            else if (percentage >= 50) bar.style.backgroundColor = '#F59E0B'; // Orange
            else bar.style.backgroundColor = '#EF4444'; // Red
        }

        if (text) {
            text.textContent = `${percentage}% (${stats.correct}/${stats.attempted})`;
        }
    },

    /**
     * Provide text feedback based on stats
     */
    analyzePerformance(stats) {
        let recommendation = "Tu hijo está empezando. ¡Anímale a practicar más!";

        const sumaRate = stats.suma.attempted > 0 ? (stats.suma.correct / stats.suma.attempted) : 0;
        const restaRate = stats.resta.attempted > 0 ? (stats.resta.correct / stats.resta.attempted) : 0;

        if (sumaRate > 0.8 && restaRate > 0.8) {
            recommendation = "¡Excelente desempeño! Está listo para desafíos mayores.";
        } else if (sumaRate > restaRate + 0.2) {
            recommendation = "Domina la suma, pero le cuesta la resta. Recomendamos enfocar las prácticas en 'Quitar/Restar'.";
        } else if (restaRate > sumaRate + 0.2) {
            recommendation = "Curiosamente, se le da mejor restar. Repasemos la suma básica.";
        } else if (stats.suma.attempted > 5 && sumaRate < 0.5) {
            recommendation = "Parece tener dificultades con el concepto base. Sugerimos usar más los bloques visuales.";
        }

        document.getElementById('dashRecommendation').textContent = recommendation;
    },

    /**
     * Handle Report Download
     */
    downloadReport() {
        if (window.ReportGenerator) {
            ReportGenerator.generateSessionReport();
        } else {
            alert('El generador de reportes no está disponible.');
        }
    },

    /**
     * Close dashboard and go home
     */
    close() {
        if (window.stopAudio) window.stopAudio();
        const dashboard = document.getElementById('parentsDashboardScreen');
        if (dashboard) {
            dashboard.classList.add('hidden');
            dashboard.classList.remove('active');
        }

        // Return to welcome screen if logged in, otherwise to login
        if (window.UserManager && window.UserManager.isLoggedIn()) {
            if (typeof window.showWelcomeScreen === 'function') {
                window.showWelcomeScreen();
            } else {
                const welcome = document.getElementById('welcomeScreen');
                if (welcome) {
                    welcome.classList.remove('hidden');
                    welcome.classList.add('active');
                }
            }
        } else {
            if (typeof window.showLoginScreen === 'function') {
                window.showLoginScreen();
            } else {
                const login = document.getElementById('loginScreen');
                if (login) {
                    login.classList.remove('hidden');
                    login.classList.add('active');
                }
            }
        }
    },

    /**
     * Change User PIN
     */
    changeUserPin(userId) {
        const user = window.UserManager.users.find(u => u.id === userId);
        if (!user) return;

        const newPin = prompt(`Nuevo PIN para ${user.name} (4 dígitos): `, user.pin || '1234');

        if (newPin !== null) {
            if (/^\d{4}$/.test(newPin)) {
                window.UserManager.updateUserPin(userId, newPin);
                alert(`✅ PIN de ${user.name} actualizado a: ${newPin} `);
                // If we are in auth screen, might need refresh, but usually we are inside dashboard
            } else {
                alert("❌ El PIN debe tener 4 números.");
            }
        }
    },

    /**
     * Change Teacher PIN
     */
    changeTeacherPin() {
        const currentPin = prompt("Introduce tu PIN actual:");
        if (currentPin !== window.UserManager.getTeacherPin()) {
            alert("❌ PIN incorrecto");
            return;
        }

        const newPin = prompt("Nuevo PIN Maestro (4 dígitos):");
        if (newPin !== null) {
            if (/^\d{4}$/.test(newPin)) {
                window.UserManager.setTeacherPin(newPin);
                alert(`✅ PIN Maestro actualizado a: ${newPin} `);
            } else {
                alert("❌ El PIN debe tener 4 números.");
            }
        }
    }
};

window.ParentsDashboard = ParentsDashboard;

// Initialize events when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const downloadBtn = document.querySelector('.btn-primary.download-report');
    if (downloadBtn) {
        downloadBtn.addEventListener('click', () => {
            window.ParentsDashboard.downloadReport();
        });
    } else {
        const reportBtn = document.getElementById('btnDownloadReport');
        if (reportBtn) {
            reportBtn.addEventListener('click', () => window.ParentsDashboard.downloadReport());
        }
    }
});
